import {review as reviewApi, reviewStatusBuyer as reviewStatusBuyer, reviewStatusSeller as reviewStatusSeller} from '../apis/review'

export function review(payload){
    return async (dispatch) => {
        let result = await reviewApi(payload);
        console.log("user request result", result);
        return result;
    }
};

export function reviewStatusBuyerCheck(payload){
    return async (dispatch) => {
        let result = await reviewStatusBuyer(payload);
        console.log("user request result", result);
        return result;
    }
};

export function reviewStatusSellerCheck(payload){
    return async (dispatch) => {
        let result = await reviewStatusSeller(payload);
        console.log("user request result", result);
        return result;
    }
};

